const scrollToTop = (containerSelector = '.main-layout-body-content') =>{
    const container = document.querySelector(containerSelector);
    if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
    } else{
        console.log("No scroll element found")
    }
}

export default scrollToTop